import type { PropsWithChildren } from 'react';
import React from 'react';

import Navigation from '../Navigation/Navigation';

const Layout: React.FC<PropsWithChildren> = ({ children, ...rest }) => {
  return (
    <main className="min-h-screen min-w-screen text-lg" {...rest}>
      <Navigation />
      <div className="min-h-screen w-[90%] max-w-[90%] flex flex-col gap-5 p-5 mx-auto">
        {children}
      </div>
    </main>
  );
};

export default Layout;
